// frontend\src\pages\Calculators\components\DevelopmentTime\constants.js
export const DEV_TIME_MULTIPLIER = 0.367;
export const INSTRUCTIONS = [
  "Отрежьте засвеченный кончик пленки",
  "Погрузите его наполовину в рабочий раствор проявителя",
  "Запустите секундомер",
  "Когда мокрая и сухая части сравняются по цвету - зафиксируйте время"
];